import { Popover } from 'antd'
import { PopoverTitle } from './popover-title'
import { useTranslation } from 'react-i18next'
import { useSafeNavigate } from '@/shared/lib/safe-navigate'
import { logout as authLogout } from '@/shared/api/auth'
import { UserAvatarIcon, LogoutIcon, BellIcon, SettingsIcon } from '@/shared/ui/icons'

export interface UserPopupModalProps {
  children: React.ReactNode
  open: boolean
  onOpenChange: (open: boolean) => void
  src?: string
  user?: { fullname?: string }
}

export function UserPopupModal({ children, open, onOpenChange, src, user }: UserPopupModalProps) {
  const navigate = useSafeNavigate()
  const { t } = useTranslation()

  const handleLogout = () => {
    authLogout().then(() => navigate('/login'))
  }

  const content = (
    <div className='flex flex-col'>
      <div
        className='m-0 py-2.5 px-5 cursor-pointer flex items-center gap-1.25 text-[13px] font-normal hover:bg-(--primary-btn-light-bg) text-(--main-title-color)'
        onClick={() => navigate('/user/user-profile')}
      >
        <UserAvatarIcon color='rgba(33, 33, 33, 1)' width='18' height='18' />
        <div>{t('profile')}</div>
      </div>
      <div
        className='m-0 py-2.5 px-5 cursor-pointer flex items-center gap-1.25 text-[13px] font-normal hover:bg-(--primary-btn-light-bg) text-(--main-title-color)'
        onClick={() => navigate('/user/notifications')}
      >
        <BellIcon color='rgba(33, 33, 33, 1)' width='18' height='18' />
        {t('notifications')}
      </div>
      <div
        className='m-0 py-2.5 px-5 cursor-pointer flex items-center gap-1.25 text-[13px] font-normal hover:bg-(--primary-btn-light-bg) text-(--main-title-color)'
        onClick={() => navigate('/user/profile-settings')}
      >
        <SettingsIcon color='rgba(33, 33, 33, 1)' width='18' height='18' />
        {t('profile_settings')}
      </div>
      <div
        className='m-0 py-2.5 px-5 cursor-pointer flex items-center gap-1.25 text-[13px] font-normal hover:bg-(--primary-btn-light-bg) text-(--main-title-color)'
        onClick={handleLogout}
      >
        <LogoutIcon width='18' height='18' />
        <div>{t('logout')}</div>
      </div>
    </div>
  )

  return (
    <div className='[&_.ant-popover-content>.ant-popover-inner]:p-[15px_22px]!'>
      <Popover
        className='p-0 [&.ant-popover-inner]:p-[15px_22px]!'
        content={content}
        title={<PopoverTitle src={src} user={user} />}
        trigger='click'
        open={open}
        onOpenChange={onOpenChange}
      >
        {children}
      </Popover>
    </div>
  )
}
